import { useNavigate } from 'react-router-dom';
import IgniteProject from './sections/IgniteProject';
import LocalPestGrid from './sections/LocalPestGrid';
import OpeningHours from './sections/OpeningHours';
import PestControlProcess from './sections/PestControlProcess';
import SecureYourCompanion from './sections/SecureYourCompanion';
import ServiceAreaGrid from './sections/ServiceAreaGrid';
import TheResellHubGuarantee from './sections/TheResellHubGuarantee';
import TransformYourHomesKerbAppeal from './sections/TransformYourHomesKerbAppeal';
import TrustBuildingDifferentiators from './sections/TrustBuildingDifferentiators';
import UltimateServices from './sections/UltimateServices';
import Topleftmenu from "./sections/Topleftmenu";
export default function Home() {
  const navigate = useNavigate();
  const handleFreeInspection = () => {
    navigate('/contact');
  };
  return <div className="w-full">
      <Topleftmenu />
      <IgniteProject onFreeInspection={handleFreeInspection} />
      <LocalPestGrid />
      <OpeningHours />
      <PestControlProcess />
      <SecureYourCompanion onFreeInspection={handleFreeInspection} />
      <ServiceAreaGrid />
      <TheResellHubGuarantee />
      <TransformYourHomesKerbAppeal onFreeInspection={handleFreeInspection} />
      <TrustBuildingDifferentiators />
      <UltimateServices onFreeInspection={handleFreeInspection} />
    </div>;
}